export default __webpack_public_path__ + "static/media/002-analysis.304134d3.svg";